module.exports = __webpack_public_path__ + "media/images/edelman-hover 2-f75e3b12aa64572addef3416643dce3e.jpg";